<div class="card" [attr.disabled]="allDisabled">
  <div class="card-header">
    <form [formGroup]="queryFormGroup" class="c-form-inline">
      <div class="d-flex align-items-center mt-2 mb-2 ml-2">
        <label class="c-form-field">
          <span class="mr-1 d-inline-block">診所</span>
          <div class="float-right">
            <app-vis-combobox formControlName="clinicCode" [valueFormat]="'valuetext'" [data]="clinics"></app-vis-combobox>
          </div>
        </label>
        <button type="button" (click)="onBtnQueryClick()" class="vis-btn-config p-0 position-relative pl-2 w-18"
          title="查詢">
          <mat-icon class="pref-icon vis-combine-icon">search</mat-icon>
          <span class="position-absolute text-xs-sm start-0 ml-4 pl-2">查詢</span>
        </button>
        <div *ngIf="labelMsg" class="alert alert-warning text-danger ml-2 mb-0 py-1 px-3 label-msg">{{ labelMsg }}</div>
        <div class="d-flex align-items-center ml-auto" *ngIf="!showLowStockOnly">
          <button type="button" (click)="expandOrShrink(true)" i18n="@@Expand"
            class="vis-btn-config p-0 position-relative pl-2 w-18" title="展開" [hidden]="isExpand">
            <mat-icon class="pref-icon vis-combine-icon">fullscreen</mat-icon>
            <span class="position-absolute text-xs-sm start-0 ml-4 pl-2">展開</span>
          </button>
          <button type="button" (click)="expandOrShrink(false)" i18n="@@Shrink"
            class="vis-btn-config p-0 position-relative pl-2 w-18" title="縮小" [hidden]="!isExpand">
            <mat-icon class="pref-icon vis-combine-icon">fullscreen_exit</mat-icon>
            <span class="position-absolute text-xs-sm start-0 ml-4 pl-2">縮小</span>
          </button>
        </div>
      </div>
    </form>
    <div *ngIf="topHint" class="font-weight-bold px-2 pb-1">※ <span [innerHTML]="topHint"></span></div>
  </div>
  <div class="card-body no-padding">
    <app-vis-grid #grid [data]="gridView" [attr.disabled]="allDisabled" [pageSize]="pageSize" [skip]="pageSkipNo"
      [pageable]="true" [selectable]="true" [kendoGridSelectBy]="'Id'" [selectedKeys]="selectedItems"
      (pageChange)="pageChange($event)" class="no-border">
      <app-vis-grid-column field="ClinicName" title="診所" [width]="70"></app-vis-grid-column>
      <app-vis-grid-column field="StoreRoomCode" title="庫別" [width]="showLowStockOnly ? 75 : 50">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.StoreRoomCode }} | {{ dataItem.StoreRoomName }}
        </ng-template>
      </app-vis-grid-column>
      <app-vis-grid-column field="ProductCode" title="貨號" [width]="50" [hide]="!showLowStockOnly"></app-vis-grid-column>
      <app-vis-grid-column field="Barcode" title="主條碼" [width]="70" [hide]="!showLowStockOnly"></app-vis-grid-column>
      <app-vis-grid-column field="ProductName" title="商品名稱" [width]="150" [hide]="!showLowStockOnly"></app-vis-grid-column>
      <app-vis-grid-column field="StockDate" title="最後庫存日期" [width]="70"
        class="text-center custom-m-auto">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span title="藍色表示當天" [ngClass]="{'text-primary': (dataItem.StockDate | formatROCFullDate:'/') == todayRoc}">
            {{ dataItem.StockDate | formatROCFullDate:'/' }}
          </span>
        </ng-template>
      </app-vis-grid-column>
      <app-vis-grid-column class="text-right header-font-blue" field="CurrentQty" title="目前庫存量" [width]="70">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [title]="dataItem.CurrentQty" [ngClass]="{
                  'text-primary': (dataItem.StockDate | formatROCFullDate:'/') == todayRoc,
                  'text-danger': dataItem.CurrentQty < 0 || dataItem.CurrentQty < dataItem.SafeStock
                }">
            {{ dataItem.CurrentQty }}
          </span>
        </ng-template>
      </app-vis-grid-column>
      <app-vis-grid-column class="text-right" field="SafeStock" title="安全存量" [width]="70"></app-vis-grid-column>
      <app-vis-grid-column field="EditTime" title="異動時間" [width]="100"
        class="text-center custom-m-auto">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.EditTime | formatROCTime:'ispadstart,timetohourmin' }}
        </ng-template>
      </app-vis-grid-column>
    </app-vis-grid>
  </div>
</div>
